module.exports = __webpack_public_path__ + "static/media/whichThinnerRegularBloodTests.fac4f11c.mp3";